import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import { Component } from 'react';

import { getSelectValue } from '../../../utils';

import StyledSelect from '../../Select';

const options = [
  {
    label: 'All Actions',
    value: null,
  },
  {
    label: 'Actions Made By Person',
    value: 'by_person',
  },
  {
    label: 'Actions Made On Person',
    value: 'on_person',
  },
];

class ActivitySelectContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activityTypeValue: options[0],
    };
    this.onChange = this.onChange.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { activityTypeValue: oldState } = this.state;
    const { activityTypeValue: newState } = nextState;

    if (!isEqual(oldState, newState)) {
      return true;
    }
    return false;
  }

  async onChange(value) {
    const { listParams, getItems } = this.props;
    await this.setState({ activityTypeValue: value });
    await getItems({ ...listParams, [value.value]: '' });
  }

  render() {
    const { activityTypeValue } = this.state;
    return (
      <StyledSelect
        value={getSelectValue(activityTypeValue, options)}
        onChange={(event, value) => this.onChange(value)}
        options={options}
        disableClearable
      />
    );
  }
}

ActivitySelectContainer.propTypes = {
  listParams: PropTypes.instanceOf(Object).isRequired,
  getItems: PropTypes.func.isRequired,
};

export default ActivitySelectContainer;
